import { render, staticRenderFns } from "./Incorrect.vue?vue&type=template&id=6da18ec1&"
import script from "./Incorrect.vue?vue&type=script&lang=ts&"
export * from "./Incorrect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports